import { object, string } from 'yup';

export const validationSchema = object({
  preferredHotelChain: string().max(100),
  specialAccommodation: string()
});
